<template>
  <div>
    <div class="risk-model-editor flex bg-white p-5 hover:bg-grey-light">
      <div class="w-9/12 flex">
        <vs-button
            @click="isOpen = !isOpen"
            class="text-dark mr-2"
            size="small"
            color="light"
            icon="expand_more"
        ></vs-button>

        <vs-input class="w-4/12" v-model="group.name"></vs-input>
      </div>
      <div class="w-3/12">
        <vs-input v-model="group.weight"></vs-input>
      </div>
    </div>
    <div :class="{'hidden': !isOpen}" class="p-2 bg-grey-light">
      <div class="grid grid-cols-6 p-5 gap-4 bg-white border-1" id="group-editor-headers">
        <div>Indicadores</div>
        <div>Indicador Slug</div>
        <div>Calificación indicador</div>
        <div>Tipo de análisis</div>
        <div>Limite inferior</div>
        <div>Limite superior</div>
      </div>
      <draggable :list="group.rules" class="cursor-move">
        <risk-model-rule-item
            @onRemoveItem="removeItemHandler"
            :key="idx"
            :rule="rule"
            :catalogs="catalogs"
            :analysis-types="analysisTypes"
            v-for="(rule, idx) in group.rules"></risk-model-rule-item>
      </draggable>

      <risk-model-rule-form
          @onAddItem="addItemHandle"
          :catalogs="catalogs"
          :analysisTypes="analysisTypes" />
    </div>
  </div>
</template>
<script>
import RiskModelRuleItem from "./RiskModelRuleItem.vue";
import draggable from 'vuedraggable'
import RiskModelRuleForm from "./RiskModelRuleForm.vue";

export default {
  name: "RiskModelGroupItem",
  components: {RiskModelRuleForm, RiskModelRuleItem, draggable},
  data: () => ({
    isOpen: false,
    analysisTypes: [
      {
        value: 'Basic',
        name: 'Básico'
      },
      {
        value: "PositiveLine",
        name: 'Lineal Positivo'
      },
      {
        value: "InverseLine",
        name: 'Lineal Inverso'
      },
      {
        value: "Catalog",
        name: "Catálogo"
      },
      {
        value: "CatalogInverseLine",
        name: "Catálogo > Linea Inversa"
      },
      {
        value: "CatalogPositiveLine",
        name: "Catálogo > Linea Positiva"
      }
    ]
  }),
  props: {
    catalogs: {
      type: Array,
      required: true,
      default: () => []
    },
    group: {
      type: Object,
      default: () => ({
        name: '',
        weight: 0,
        indicators: []
      })
    }
  },
  methods: {
    addItemHandle(ev) {
      this.group.rules.push(ev)
      this.$emit('onAddItem', this.group)
    },
    removeItemHandler(rule) {
      this.group.rules = this.group.rules.filter((item) => {
        return item !== rule
      })
      this.$emit('onRemoveItem', this.group)
    }
  }
}
</script>
<style scoped>

</style>